import { Component } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { NotificationComponent } from '@tdwb/core';
import { AgreementsBase } from '../agreements.base';

@Component({
  selector: 'td-wb-old-ceg',
  templateUrl: './old-ceg.component.html',
  styleUrls: ['../agreements.component.scss'],
  imports: [NgTemplateOutlet, NotificationComponent]
})
export class OldCegComponent extends AgreementsBase {
  constructor() { super(); }
}
